import { useEffect } from 'react';

const EMBED_SRC = 'https://link.msgsndr.com/js/form_embed.js';

export const GhlCalendar = ({ src, id, title, testid }) => {
  useEffect(() => {
    if (document.querySelector(`script[src="${EMBED_SRC}"]`)) return;
    const s = document.createElement('script');
    s.src = EMBED_SRC;
    s.async = true;
    document.body.appendChild(s);
  }, []);

  return (
    <div data-testid={`${testid}-container`} className="rounded-3xl p-2 sm:p-3 bg-white/5 border border-white/10 shadow-[0_40px_80px_-30px_rgba(0,0,0,0.8)]">
      <iframe
        src={src}
        id={id}
        title={title}
        scrolling="no"
        data-testid={testid}
        className="w-full min-h-[760px] rounded-2xl border-0 bg-white"
      />
    </div>
  );
};
